export const OVERLAY_AXIS_ID = 'y2';

export interface OverlayConfig {
  /** Same data-object shape as the chart's primary `dataObjects` (verbatim `label` or `name`, `time`, `[dataset]`). */
  dataObjects: any[];
  dataset: string;
  label: string;
  unit: string;
  /** The primary (left-axis) variable — when set, the left axis is titled too so both axes are labelled. */
  primaryLabel?: string;
  primaryUnit?: string;
}

/** Dashed datasets on the secondary (right) axis; data objects lacking the variable are skipped. */
export function buildOverlayDatasets(
  overlay: OverlayConfig,
  makeDataset: (x: Date[], y: number[], label: string) => any,
): any[] {
  return overlay.dataObjects
    .filter((o) => Array.isArray(o[overlay.dataset]) && o[overlay.dataset].length)
    .map((o) => ({
      ...makeDataset(o.time.map((t: any) => new Date(t)), o[overlay.dataset], `${overlay.label}: ${o.label ?? o.name ?? ''}`),
      yAxisID: OVERLAY_AXIS_ID,
      borderDash: [6, 4],
      overlayKey: overlay.dataset,
    }));
}

/** Left-axis title shown only while an overlay is active (a single series is already identified by title/legend). */
export function buildPrimaryAxisTitle(overlay: OverlayConfig): { display: true; text: string } | null {
  if (!overlay.primaryLabel) return null;
  const unit = overlay.primaryUnit ? ` (${overlay.primaryUnit})` : '';
  return { display: true, text: `${overlay.primaryLabel}${unit}` };
}

export function buildOverlayScale(overlay: OverlayConfig): Record<string, any> {
  return {
    type: 'linear',
    position: 'right',
    title: { display: true, text: `${overlay.label} (${overlay.unit})` },
    grid: { drawOnChartArea: false },
    ticks: {},
  };
}
